import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ROUTE_PATHS } from '@/lib/index';
import { LangProvider } from '@/hooks/useLang';
import Layout from '@/components/Layout';
import { lazy, Suspense, useEffect } from 'react';

/* ── Lazy-loaded pages — fiecare pagina = chunk JS separat (code splitting) */
const Home              = lazy(() => import('@/pages/Home'));
const WebDesign         = lazy(() => import('@/pages/WebDesign'));
const CallCenter        = lazy(() => import('@/pages/CallCenter'));
const ITHardware        = lazy(() => import('@/pages/ITHardware'));
const Hosting           = lazy(() => import('@/pages/Hosting'));
const VoIP              = lazy(() => import('@/pages/VoIP'));
const CRMSoftware       = lazy(() => import('@/pages/CRMSoftware'));
const Contact           = lazy(() => import('@/pages/Contact'));
const Clients           = lazy(() => import('@/pages/Clients'));
const Termeni           = lazy(() => import('@/pages/Termeni'));
const Confidentialitate = lazy(() => import('@/pages/Confidentialitate'));
const Retur             = lazy(() => import('@/pages/Retur'));
const NDA               = lazy(() => import('@/pages/NDA'));
const Cookies           = lazy(() => import('@/pages/Cookies'));
const Blog              = lazy(() => import('@/pages/Blog'));
const BlogCategory      = lazy(() => import('@/pages/BlogCategory'));
const BlogArticle       = lazy(() => import('@/pages/BlogArticle'));
const NotFound          = lazy(() => import('@/pages/NotFound'));

/* ── GTM virtual pageview tracker pentru BrowserRouter SPA ─────────────────── */
function GTMPageTracker(): null {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== 'undefined' && Array.isArray((window as any).dataLayer)) {
      (window as any).dataLayer.push({
        event: 'virtualPageview',
        page_path: location.pathname + location.search,
        page_title: document.title,
        page_location: window.location.href,
      });
    }
  }, [location.pathname, location.search]);
  return null;
}

/* ── Loading skeleton minimal — fara CLS, fara flash alb ────────────────── */
function PageLoader() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center" aria-hidden="true">
      <div className="w-8 h-8 rounded-full border-2 border-[#4ab8ff]/30 border-t-[#4ab8ff] animate-spin" />
    </div>
  );
}

export default function App() {
  return (
    <LangProvider>
      <Router>
        <GTMPageTracker />
        <Layout>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path={ROUTE_PATHS.HOME}              element={<Home />} />
              <Route path={ROUTE_PATHS.WEB_DESIGN}        element={<WebDesign />} />
              <Route path={ROUTE_PATHS.CALL_CENTER}       element={<CallCenter />} />
              <Route path={ROUTE_PATHS.IT_HARDWARE}       element={<ITHardware />} />
              <Route path={ROUTE_PATHS.HOSTING}           element={<Hosting />} />
              <Route path={ROUTE_PATHS.VOIP}              element={<VoIP />} />
              <Route path={ROUTE_PATHS.CRM_SOFTWARE}      element={<CRMSoftware />} />
              <Route path={ROUTE_PATHS.CONTACT}           element={<Contact />} />
              <Route path={ROUTE_PATHS.CLIENTS}           element={<Clients />} />
              <Route path={ROUTE_PATHS.TERMENI}           element={<Termeni />} />
              <Route path={ROUTE_PATHS.CONFIDENTIALITATE} element={<Confidentialitate />} />
              <Route path={ROUTE_PATHS.RETUR}             element={<Retur />} />
              <Route path={ROUTE_PATHS.NDA}               element={<NDA />} />
              <Route path={ROUTE_PATHS.COOKIES}           element={<Cookies />} />
              <Route path={ROUTE_PATHS.BLOG}              element={<Blog />} />
              <Route path={ROUTE_PATHS.BLOG_CATEGORY}     element={<BlogCategory />} />
              <Route path={ROUTE_PATHS.BLOG_ARTICLE}      element={<BlogArticle />} />
              <Route path="*"                             element={<NotFound />} />
            </Routes>
          </Suspense>
        </Layout>
      </Router>
    </LangProvider>
  );
}
